import TransactionStatusBanking from "./TransactionStatusBanking";

export default TransactionStatusBanking;
